import type { ReactNode } from "react";
import { Header } from "../landing-clinic/components/Header";
import { Footer } from "../landing-clinic/components/Footer";
import { HelpPanel } from "@/shared/help/components/HelpPanel";
import { PublicSeo } from "./PublicSeo";

type PublicClinicShellProps = {
  children: ReactNode;
  seo: {
    title: string;
    description: string;
    path: string;
  };
};

/** Layout público B2B (landing clínica): header, contenido scrollable, ayuda y footer. */
export function PublicClinicShell({ children, seo }: PublicClinicShellProps) {
  return (
    <div className="flex flex-col h-screen overflow-hidden bg-background text-foreground custom-scrollbar">
      <PublicSeo title={seo.title} description={seo.description} path={seo.path} />
      <Header />
      <div className="flex flex-1 min-h-0 relative overflow-hidden">
        <div className="flex flex-1 flex-col min-h-0 overflow-y-auto">
          {children}
          <Footer />
        </div>
        <HelpPanel contextScope="PUBLIC_CLINIC" />
      </div>
    </div>
  );
}
